import { Modal } from "antd";
import styled from "styled-components";

export const CompanyPageWrapper = styled.div<{
  listdata: number;
}>`
  .company-page-header {
    background-color: #ffffff;
    display: flex;
    border-radius: 1px;
    width: 100%;
    margin-top: -8px;
    margin-bottom: 8px;
    height: 64px;
    &_title {
      font-size: 28px;
      font-weight: var(--font-bold);
      color: var(--color-text-primary);
      padding: 10px 16px;
    }
  }
  .company-page-body {
    background-color: #ffffff;
    border-radius: 1px;
    width: 100%;
    &__search-btn {
      width: 100%;
      top: 32px;
      height: 48px;
      font-weight: 700;
      background-color: var(--color-primary);
      color: #ffffff;
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    &__search-btn-disable {
      width: 100%;
      top: 32px;
      height: 48px;
      background-color: #eaecf0;
      font-weight: 700;
      color: #98a2b3;
    }
    &__input-disable {
      border-color: #98a2b3 !important;
      color: #070708;
      font-weight: 400;
      &:hover {
        border-color: #98a2b3 !important;
      }
    }
    &__clear-btn {
      width: 100%;
      top: 32px;
      height: 48px;
      font-weight: 700;
      border-color: var(--color-primary);
      color: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    &__add-new-btn {
      width: 100%;
      top: 32px;
      height: 48px;
      font-weight: 700;
      border-color: var(--color-primary);
      color: var(--color-primary);
      background: var(--bg-color);

      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: var(--color-primary) !important;
      }
    }
    &__search-drop-down {
      height: 50px !important;
      &:hover {
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    form {
      .ant-select-single,
      .ant-input-affix-wrapper {
        height: 48px;
      }
      .ant-input {
        height: 48px;
      }
      .ant-select-selector {
        height: 48px;
      }
      .ant-select-selector {
        .ant-select-selection-search {
          .ant-select-selection-search-input {
            height: 100%;
            font-size: var(--font-size-xl);
            font-weight: var(--font-medium);
          }
        }
      }
    }
    .ant-pagination {
      display: none;
    }
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-select-focused .ant-select-selector,
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-input-outlined:focus-within {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-select-arrow {
      top: 45%;
      margin-top: 0;
      height: 6px;
      font-size: 12px;
      color: var(--color-text-primary);
      inset-inline-end: 16px;
    }
    &__alert-table {
      padding: 16px;
      height: 100%;
      .cell-data {
        // margin-top: 10px;
      }
      &--status-bad {
        color: #ffffff;
        font-weight: 700;
        margin-top: 10px;
      }
      &--status-good {
        color: #0d9d68;
        font-weight: 700;
        margin-top: 10px;
      }
      &--check-status-button {
        width: 100%;
        height: 48px;
        font-weight: 700;
        color: var(--color-primary);
        background-color: #fff7eb;
        border-color: var(--color-primary);
        &:hover {
          background-color: var(--color-primary) !important;
          border-color: var(--color-hover-primary) !important;
          color: #ffffff !important;
        }
      }
      .ant-table-tbody {
        height: ${(props) => (props.listdata > 0 ? "unset" : "580px")};
        .ant-table-row {
          .ant-table-cell {
            .list-page_modal-btns {
              display: flex;
              justify-content: center;
              column-gap: 26px;

              .ant-btn-default {
                padding: 0;
                height: unset;
                border-color: transparent;
                box-shadow: none;
                background: none;
              }

              .ant-btn-default:disabled {
                border-color: transparent;
                background: transparent;
              }
            }
          }
        }
      }
    }
  }
`;

export const ModalWrapper = styled(Modal)`
  .ant-modal-header {
    margin-bottom: 0;
    padding: 16px 24px;
    background: none;

    .ant-modal-title {
      display: flex;
      align-items: center;
      column-gap: 12px;

      button {
        width: 48px;
        height: 48px;
        background-color: #edeff1;
        border-radius: 100%;
        border: none;
        position: relative;
        cursor: pointer;

        svg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      span {
        font-weight: var(--font-bold);
        font-size: var(--font-size-base);
        line-height: 24px;
      }
    }
  }

  .ant-modal-content {
    padding: 0;
    background: var(--color-white);
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.08);
    border-radius: 12px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    column-gap: 16px;
    padding: 12px 24px 24px;
    margin-top: 0;

    .ant-btn {
      width: 368px;
      height: 48px;
      box-shadow: none;
      font-weight: var(--font-bold);
      margin-inline-start: 0;
    }

    .ant-btn-default {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .ant-btn-primary {
      margin-inline-start: 0 !important;
    }
    .regis-company-modal {
      &__regis-disable {
        background-color: #eaecf0;
        color: #98a2b3;
      }
      &__regis-ok {
        color: var(--color-white);
        border-color: 1px solid var(--color-primary);
        background: var(--color-primary);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
      &__regis-cancel {
        color: var(--color-primary);
        border-color: 1px solid var(--color-primary);
        background: var(--color-white);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
    }
  }

  .ant-modal-body {
    padding: 16px 24px;
    border-bottom: 1px solid #f1f3f7;
    border-top: 1px solid #f1f3f7;

    .ant-form {
      display: flex;
      justify-content: space-between;
      column-gap: 16px;

      .ant-select-selection-placeholder,
      input::placeholder {
        font-size: var(--font-size-sm);
        font-weight: var(--font-medium);
        color: var(--color-border-primary);
      }

      .company-page_modal-form-left,
      .company-page_modal-form-right {
        width: 368px;
        .ant-form-item:not(:last-child) {
          margin-bottom: 16px;
        }

        .ant-form-item:last-child {
          margin-bottom: 0;
        }

        .ant-form-item-label {
          padding: 0 0 4px;

          label {
            font-weight: var(--font-normal);
          }
        }

        .ant-picker {
          width: 100%;
          height: 56px;
        }

        .ant-select-lg,
        .ant-input-lg,
        .ant-input-number-lg {
          height: 56px;
        }

        .ant-input-number-lg {
          width: 368px;

          .ant-input-number-input {
            height: 54px;
            padding: 16px;
            font-size: var(--font-size-xl);
            font-weight: var(--font-medium);
          }
        }

        .ant-select-in-form-item {
          width: 368px;

          .ant-select-selector {
            padding: 16px;

            .ant-select-selection-item {
              font-size: var(--font-size-xl);
              font-weight: var(--font-medium);
              line-height: 24px;
            }
          }

          .ant-select-arrow {
            inset-inline-end: 16px;
          }
        }

        .ant-input-lg {
          padding: 16px;
          font-size: var(--font-size-xl);
          font-weight: var(--font-medium);
          line-height: 24px;
        }

        .ant-picker-large {
          padding: 16px;

          input {
            font-size: var(--font-size-xl);
            font-weight: var(--font-medium);
            line-height: 24px;
          }
        }

        /* Disabled */
        .ant-select-disabled .ant-select-selector,
        .ant-input-disabled,
        .ant-input-number-disabled {
          color: var(--color-secondary);
          background: var(--color-border-primary);
          &:hover {
            border-color: var(--color-border-primary) !important;
          }
        }

        .ant-picker-disabled input {
          color: var(--color-secondary);
        }

        .ant-picker-disabled {
          background: var(--color-border-primary);
        }
      }
    }
  }
  form {
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-picker-outlined:focus-within {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-select-focused .ant-select-selector,
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-input-outlined:focus-within {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-select-arrow {
      top: 45%;
      margin-top: 0;
      height: 6px;
      font-size: 12px;
      color: var(--color-text-primary);
      inset-inline-end: 16px;
    }
    .second-row {
      margin-top: -17px;
    }
  }
`;

export const ModalDeleteWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    background: var(--color-white);
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.08);
    border-radius: 12px;
  }

  .ant-modal-header {
    margin-bottom: 0;
    padding: 16px 24px;
    background: none;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
      line-height: 24px;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    column-gap: 16px;
    padding: 12px 24px 24px;
    margin-top: 0;

    .ant-btn {
      width: 202px;
      height: 48px;
      box-shadow: none;
      font-weight: var(--font-bold);
      margin-inline-start: 0;
    }

    .ant-btn-default {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }

    .delete-company-modal {
      &__delete-ok {
        color: var(--color-white);
        border-color: 1px solid var(--color-primary);
        background: var(--color-primary);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
      &__delete-cancel {
        color: var(--color-primary);
        border-color: 1px solid var(--color-primary);
        background: var(--color-white);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
    }

    .company-page_modal-regist-success_btn-ok {
      color: var(--color-white);
      border-color: 1px solid var(--color-primary);
      background: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: 1px solid var(--color-primary) !important;
        color: var(--color-primary) !important;
      }
    }

    .modal-confirm-final {
      &__btn-ok {
        color: var(--color-white);
        border-color: 1px solid var(--color-primary);
        background: var(--color-primary);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
      &__btn-cancel {
        color: var(--color-primary);
        border-color: 1px solid var(--color-primary);
        background: var(--color-white);
        &:hover {
          background-color: var(--color-hover-primary) !important;
          border-color: 1px solid var(--color-primary) !important;
          color: var(--color-primary) !important;
        }
      }
    }
  }

  .ant-modal-body {
    padding: 0 24px;
    border-bottom: 1px solid #f1f3f7;
    border-top: 1px solid #f1f3f7;
    text-align: center;

    .company-page_modal-delete {
      margin: 30px 0 24px;

      p:first-child {
        color: var(--color-text-secondary);
        font-weight: var(--font-normal);
        margin-bottom: 16px;
      }

      p:last-child {
        font-weight: var(--font-medium);
        font-size: var(--font-size-sm);
        line-height: 20px;
      }
    }

    .company-page_modal-regist-success,
    .company-page_modal-confirm {
      p {
        font-weight: var(--font-medium);
        font-size: var(--font-size-sm);
        line-height: 24px;
      }
    }

    .company-page_modal-regist-success {
      margin: 24px 0 16px;
    }

    .company-page_modal-confirm {
      p {
        margin: 48px 0 40px;
      }
    }
  }
`;
